var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeatureVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 46.6383,
    height: 29.5679,
    viewBox: "0 0 46.6383 29.5679",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.7954 0.727917H7.33083C3.67195 0.727917 0.705833 3.69403 0.705833 7.35292V22.215C0.705833 25.8739 3.67195 28.84 7.33083 28.84H21.7954C25.4543 28.84 28.4204 25.8739 28.4204 22.215V7.35292C28.4204 3.69403 25.4543 0.727917 21.7954 0.727917Z",
    fill: "#1B2A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.375 0.75H21.7954C25.4543 0.75 28.4204 3.71611 28.4204 7.375V22.1929C28.4204 25.8518 25.4543 28.8179 21.7954 28.8179H7.375C3.71611 28.8179 0.75 25.8518 0.75 22.1929V7.375C0.75 3.71611 3.71611 0.75 7.375 0.75Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#1B2A4A"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M45.8883 18.2842V11.4383C45.8883 8.41292 45.8883 6.88917 45.2037 6.00583C44.7193 5.36996 44.0212 4.93073 43.2383 4.76917C42.1342 4.54833 40.765 5.21083 38.0488 6.53583C36.8783 7.08792 36.2821 7.375 35.8625 7.81667C35.5811 8.14897 35.3504 8.52105 35.1779 8.92083C34.9571 9.495 34.9571 10.1354 34.9571 11.4383V18.2842C34.9571 19.6092 34.9571 20.2717 35.1779 20.8458C35.3251 21.2433 35.5607 21.6114 35.8846 21.95C36.3262 22.3917 36.9225 22.6788 38.0929 23.2308C40.8312 24.4896 42.1783 25.13 43.2604 24.8871C44.0554 24.7104 44.7032 24.3056 45.2037 23.6725C45.8663 22.7892 45.8662 21.2875 45.8662 18.2842",
    fill: "#1B2A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8883 18.2842V11.4383C45.8883 8.41292 45.8883 6.88917 45.2038 6.00583C44.7193 5.36996 44.0212 4.93073 43.2383 4.76917C42.1342 4.54833 40.765 5.21083 38.0488 6.53583C36.8783 7.08792 36.2821 7.375 35.8625 7.81667C35.5811 8.14897 35.3504 8.52105 35.1779 8.92083C34.9571 9.495 34.9571 10.1354 34.9571 11.4383V18.2842C34.9571 19.6092 34.9571 20.2717 35.1779 20.8458C35.3251 21.2433 35.5607 21.6114 35.8846 21.95C36.3262 22.3917 36.9225 22.6788 38.0929 23.2308C40.8312 24.4896 42.1783 25.13 43.2604 24.8871C44.0554 24.7104 44.7032 24.3056 45.2038 23.6725C45.8663 22.7892 45.8662 21.2875 45.8662 18.2842",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#1B2A4A"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureVideo);
export default __webpack_public_path__ + "static/media/feature-video.b7a41a2daac0e5ab40e930e3fe84f375.svg";
export { ForwardRef as ReactComponent };